import { Api } from '@axiom/ui';
import type { User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

// Distinct class name (not `UserApiClass`) so it doesn't collide with the
// generated `api/generated/user-api.ts` client in the apiUnitHelper scanner,
// which keys methods by class name — a shared name would shadow the generated
// twin and hide its methods (e.g. patchUser) from `listen()`.
class SessionUserApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  // Schema-less on purpose: the /user/me/settingsInfo payload embeds `settings`
  // rows that have no `id`, but UserEntity normalizes `settings` as
  // UserSettingEntity (pk = id) — which makes the Data Client throw "Missing
  // usable primary key". So this read uses the legacy URL-keyed cache (as it
  // did before type generation). user-settings-util invalidates it explicitly
  // after a settings write.
  readSessionUser() {
    return super.read<{ data: User }>({
      endpoint: '/user/me/settingsInfo',
      method: 'GET',
    });
  }
}

export const UserApi = new SessionUserApiClass();
